// 9fbef606107a605d69c0edbcd8029e5d
import { MERGE_ACCOUNT_ACCOUNT_CONFIRMATION_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import { createSelector } from 'reselect';
import ACCOUNT_CONFIRMATION_CONSTANTS from '../AccountConfirmation.constants';
import {
  GLOBAL_HELPCENTER_LABELS,
  GlobalHelpCenterLabels,
  lblAccntVerificationError,
} from '../../../../../../../../../utils/labels/globalHelpCenter.labels';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
} from '../../../../../../../../../utils/labels/labelUtilty';

export const getAccountConfirmationFailure = (state) => {
  return state[MERGE_ACCOUNT_ACCOUNT_CONFIRMATION_REDUCER_KEY]?.get('error');
};

export const getAccountConfirmationSuccess = (state) => {
  return state[MERGE_ACCOUNT_ACCOUNT_CONFIRMATION_REDUCER_KEY]?.get('accountConfirmationSuccess');
};

const errorMessage = (error) =>
  error === ACCOUNT_CONFIRMATION_CONSTANTS.ACCOUNT_INVALID
    ? getLabelFromCopyOrFromTranslation(
        `${GLOBAL_HELPCENTER_LABELS}.${lblAccntVerificationError}`,
        GlobalHelpCenterLabels
      )
    : getDynamicLabelValues('dynamic.error_messages.lbl_errorMessages_DEFAULT');

export const getMergeAccountConfirmationError = createSelector(
  getAccountConfirmationFailure,

  (error) => (error ? errorMessage(error) : null)
);
